<template>
  <main id="app" class="app-grid">
    <Navigation
      id="header"
      :sections="{}"
      :otherRoutes="otherRoutes"
      currentSection="resume"
      :showHome="true"
      :wasHome="wasHome"
      :showRule="false"
      :hideLogo="true"
      backAlt="Back Home"
    />
    <iframe
      class="resume-page"
      src="https://resume.duo-yang.com/"
      frameborder="0"
    ></iframe>
  </main>
</template>

<style lang="scss">
@import '@/styles/base.scss';

// // Scoped font size
// $resume-font-size: 12px;
// $resume-line-height: $resume-font-size * 1.5;
// $resume-baseline: $resume-line-height / 2;

// $logo-margin: 4px; // logo margin
// $logo-height-round: 104px;
// $width-letter-grid: 670px; // column 4*136

// // Global styles

// .overline {
//   text-transform: uppercase;
//   line-height: $resume-line-height;
//   letter-spacing: 0;
//   padding-top: 0;
//   padding-bottom: 0;
//   margin-top: 0;
//   margin-bottom: 0;
//   font-weight: 600;
// }

// .tnum {
//   font-feature-settings: 'tnum' 1;
// }

// .right {
//   text-align: right;
// }

// .logo {
//   grid-column: 1 / span 1;
//   grid-row: 1 / span 2;
//   height: $logo-height-round;

//   a {
//     text-decoration: none;
//     display: block;
//     line-height: 0;
//     margin: 0;
//     padding: 0;
//   }

//   .logo-anime {
//     margin: 0 !important;
//     margin-top: -36px !important;
//     margin-left: -40px !important;
//   }
// }

// .name {
//   grid-column: 2 / span 2;
//   grid-row: 1 / span 1;
//   padding-bottom: $logo-margin;

//   h1 {
//     text-transform: uppercase;
//     margin-top: 0;
//   }
// }

// .folio {
//   grid-column: 4 / span 1;
//   grid-row: 1 / span 1;

//   .portfolio {
//     display: block;
//     font-weight: 600;
//     font-size: $h4-size;
//     color: $primary-color;
//     text-decoration: underline;
//   }

//   .overline {
//     padding-bottom: $logo-margin;
//     color: $text-light-third;
//   }
// }

// .bio {
//   grid-column: 2 / span 2;
//   grid-row: 2 / span 1;
//   padding-top: $resume-line-height;
//   padding-bottom: 0;

//   p {
//     display: block;
//     color: $text-light-second;
//     margin: 0;
//   }
// }

// .contact {
//   grid-column: 4 / span 1;
//   grid-row: 2 / span 1;
//   padding-top: $resume-line-height;
//   padding-bottom: 0;

//   a {
//     text-decoration: none;
//     display: block;
//   }
// }

// .edu {
//   grid-column: 1 / span 1;
//   grid-row: 3 / span 1;
// }

// .experience {
//   grid-column: 2 / span 3;
//   grid-row: 3 / span 2;

//   a {
//     text-decoration: none;
//   }
// }

// .skills {
//   grid-column: 1 / span 1;
//   grid-row: 4 / span 1;
// }

// // Content styles

// .content {
//   .sweep-right:hover:before,
//   .sweep-right:focus:before,
//   .sweep-right:active:before {
//     transform: scaleX(1.3) !important;
//   }

//   h2.overline {
//     font-size: $h4-size;
//     margin-top: $resume-baseline;
//     margin-left: 0;
//     color: $primary-color;
//   }

//   .block {
//     padding-top: $resume-baseline * 0.5;
//     padding-bottom: $resume-baseline;
//     transition: all 0.3s;

//     li,
//     p {
//       margin-bottom: 0;
//     }

//     ul {
//       list-style: none;
//       padding-left: 0;
//     }

//     h3,
//     h4 {
//       padding-top: $resume-baseline * 0.5;
//       padding-bottom: $resume-baseline * 0.25;
//       margin-bottom: 0;
//     }

//     h4 {
//       font-weight: 600;
//     }

//     .info {
//       display: block;
//       color: $text-light-second;
//       font-size: 0.9rem;
//       margin-top: $resume-baseline * -0.25;
//       margin-bottom: 0;

//       address {
//         display: inline;
//       }
//     }

//     .title {
//       display: grid;
//       grid-template-columns: repeat(3, 1fr);
//       grid-column-gap: $column-gap;

//       h3 {
//         grid-column: span 2;
//       }
//       address {
//         grid-column: span 2;
//       }
//       time {
//         grid-column: span 1;
//       }
//       .spec {
//         grid-column: span 1;
//         padding-top: $resume-baseline * 0.5;
//         font-weight: 600;
//       }
//       .info {
//         padding-bottom: $resume-baseline * 0.25;
//       }
//     }
//   }
// }

// // Filter styles

// .lang {
//   display: none !important;
// }

// .second {
//   display: none;
// }

// .collection {
//   display: none;
// }

// Transitions

// .sweep-right {
//   display: inline-block;
//   transform: perspective(1px) translateZ(0);
//   transition-property: color;
//   transition-duration: 0.3s;
// }
// .sweep-right:before {
//   background: $primary-color;
//   content: '';
//   position: absolute;
//   z-index: -1;
//   top: 0;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   transform: scaleX(0);
//   transform-origin: 0 50%;
//   transition-property: transform;
//   transition-duration: 0.3s;
//   transition-timing-function: ease-out;
// }

// .sweep-right:hover,
// .sweep-right:focus,
// .sweep-right:active {
//   cursor: pointer;
//   color: $text-dark !important;

//   * {
//     color: $text-dark !important;
//   }
// }
// .sweep-right:hover:before,
// .sweep-right:focus:before,
// .sweep-right:active:before {
//   transform: scaleX(1);
// }

// @media only screen {
//   .experience,
//   .skills {
//     padding-bottom: $resume-line-height * 3;
//   }
// }

// Grid layout

.resume-page {
  grid-column: 1 / -1;
  grid-row: 1 / -1;
  display: block;
  margin: 0;
  height: 100vh;
  width: 100%;

  // iframe {
  //   width: 100%;
  //   height: 100%;
  // }
  // display: grid;
  // padding: $resume-line-height * 2 $body-padding $resume-line-height * 3;
  // grid-template-columns: repeat(4, 1fr);
  // grid-column-gap: $column-gap;
  // overflow-y: scroll;
}

@media only print {
  body {
    // background-color: transparent;
    margin: 0;
    padding-bottom: 0 !important;
  }

  header {
    display: none !important;
  }

  .print {
    display: block;
  }

  .logo-anime {
    position: absolute;
  }

  // iframe {
  //   margin: 0;
  // }

  .resume-page {
    // max-width: $width-letter-grid;
    margin: 0 auto;
    padding: 0;
  }
}
</style>

<script>
// @ is an alias to /src
// import ResumeExp from '@/components/ResumeExp.vue'
// import AnimeLogo from '@/components/Animation/logo.vue'

// const defaultFilter = 'primary'

import Navigation from '@/components/Navigation.vue'

export default {
  name: 'resume',
  components: {
    // ResumeExp,
    // AnimeLogo
    Navigation
  },
  data() {
    return {
      routes: this.$store.state.nav.routes
    }
  },
  computed: {
    otherRoutes() {
      let res = {}
      Object.assign(res, this.routes)
      delete res.home
      delete res.resume
      return res
    },
    wasHome() {
      return this.$store.state.nav.lastRouteName === 'home'
    }
  }
  // data() {
  //   return {
  //     exps: this.$store.state.resume.exps,
  //     activeFilter: defaultFilter
  //   }
  // },
  // props: {
  //   motto: {
  //     type: String,
  //     default: 'User Experience Designer / Engineer / Explorer'
  //   }
  // },
  // methods: {
  //   shouldShowExp(tags, filter) {
  //     return tags.indexOf(filter) >= 0
  //   }
  // }
}
</script>
